import {AddPodRoom} from '@/graphql/mutations/Pod.graphql'

export default {
  data(){
    return {
      isLoadingCreateAction : false
    };
  },

  methods   : {
    emptyFlashMessageCreatePod(){
      this.$store.dispatch({
        type        : 'flashMessage/updateFlashMessage',
        hasMessage  : true,
        message     : '&nbsp;きなこきびだんごが不足しています。',
        status      : 'error',
        hasControl  : true,
        autoClose   : 8000
      }, {root:true});
    },

    // 新規作成はここ
    async handleClickSubmitCreateButton(inputText){
      if(inputText === '' || inputText === null) return;

      const characterItemStoreData = this.couldUseStoryItemValidation('kinako-kibidango');
      
      if( characterItemStoreData !== false ){
        this.isLoadingCreateAction = true;

        await this.UXWaiting(1000);

        this.displayUseStoryItemConfirmModal({
          characterItemStore    : characterItemStoreData,
          templateName          : 'addCharacterToPodRoom',

          itemRequireAmount     : 1,  // 使用するアイテムの数

          handleSubmitFunction  : async() => {
            await this.handleCreateButtonItemUseAccept(inputText);
          },

          handleCancelFunction  : async () => {
            await this.handleCreateButtonItemUseRejected();
          }
        });
      }
    },

    handleClickCancelCreateButton(){
      this.viewType = 'list';
    },

    async handleCreateButtonItemUseAccept(inputText){
      if(inputText === '' || inputText === null) return;

      this.$store.dispatch({
        type            : 'itemUseModal/updateOpenModal',
        isSubmitLoading : true,
      });

      await this.UXWaiting(500);

      // ここでポッドを作成する
      await this.executeCreatePod(inputText);

      //アイテム消費確認モーダルを閉じる
      this.$store.dispatch({
        type            : 'itemUseModal/updateOpenModal',
        value           : false,
        isSubmitLoading : false
      });

      this.viewType = 'loading';
      
      this.loadingViewType = 'loading';

      this.isDisabledCreateButton = true;

      await this.UXWaiting(4000);

      this.loadingViewType = 'complete';

      await this.UXWaiting(3000);

      this.isDisabledCreateButton = false;
      this.viewType = 'list';
    },

    async handleCreateButtonItemUseRejected(){
      this.$store.dispatch({  
        type            : 'itemUseModal/updateOpenModal',
        value           : false,
        isSubmitLoading : false
      });

      this.isLoadingCreateAction = false;
    },

    executeCreatePod(inputText){
      return new Promise((resolve) => {
        this.$apollo.mutate({
          mutation  : AddPodRoom,
          variables : {
            name  : inputText
          },
          update    : (store, {data: {podRoom}}) => {
            if(podRoom !== null){
              this.$apollo.queries.joinedPodRoomList.refetch();
              this.$apollo.queries.characterItemStoreList.refetch();
            }else{
              this.$store.dispatch({
                type        : 'flashMessage/updateFlashMessage',
                hasMessage  : true,
                message     : '&nbsp;エラーが発生しました。',
                status      : 'error',
                hasControl  : true,
                autoClose   : 8000
              }, {root:true});
            }
          }
        }).then(async () => {
          resolve(true);
        }).catch(async (error) => {
          console.error(error);

          resolve(false);
        });
      });
    }
  }
}